import Navbar from "components/Navbar"
import SeminarAll from "components/Seminar/SeminarAll"
import Footer from "components/Footer";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import { useEffect } from "react";
// import WorkshopVids from "components/Seminar/WorkshopVids";


function Seminars () {

    const isMobile = useSelector(state => state.windowSize.isMobile);
    
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <SeminarAll />
            {/* <WorkshopVids /> */}
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <SeminarAll />
            {/* <WorkshopVids /> */}
            <Footer />
            </>
        )}
        </>
    )
}

export default Seminars